import { setCookie } from '@/lib/config/cookies';
import type { ChartMode, YAxisProperty } from './types';

export const CHART_METRIC_COOKIE = 'morfi-chart-metric';

export function parseChartMetricPreference(value: string | undefined): {
  chartMode: ChartMode;
  yAxisProperty: YAxisProperty;
} {
  if (value === 'price' || value === 'marketCap') {
    return { chartMode: 'live', yAxisProperty: value };
  }
  return { chartMode: 'consensus', yAxisProperty: 'marketCap' };
}

/** Local storage owns the preference; this mirror lets SSR prefetch its metric. */
export function writeChartMetricCookie(state: {
  chartMode: ChartMode;
  yAxisProperty: YAxisProperty;
}): void {
  if (typeof document === 'undefined') return;
  setCookie(
    CHART_METRIC_COOKIE,
    state.chartMode === 'consensus' ? 'consensus' : state.yAxisProperty,
    365 * 24 * 60 * 60,
  );
}
